import i18next from 'i18next';
import { _URL_FORM, abrirFormCadastro, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { progressoCurriculo } from './progresso';

export const redeSocial = function () {
    "use strict";

    var $divPanel = '#panel-social';
    var $panel = body.find($divPanel);
    var $elementNull = document.getElementById("social-null");
    var _excluir = function (id) {
        swal({
            title: i18next.t('socialRemoverTitle'),
            html: i18next.t('socialRemoverDesc'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('btnSimRemover'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function () {
            window.global.loaderPanel.show($divPanel);
            $.ajax({
                type: "GET",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DeleteRedeSocial?id=' + id, cache: false,
                success: function (data) {
                    if (data.success == 1) {
                        toastr.success(i18next.t('socialRemoverSucesso'), '', { "closeButton": true });
                        if (id == 15) {
                            $panel.find('#elemento-whatsapp').removeClass('hide');
                            $panel.find('#social-item-15').remove();
                        }
                        else if (id == 2) {
                            $panel.find('#elemento-linkedin').removeClass('hide');
                            $panel.find('#social-item-2').remove();
                        }
                        else {
                            $panel.find('#social-item-' + id).remove();
                        }
                        progressoCurriculo();
                        _listar();
                    } else {
                        swal("", data.error, "error");
                    }
                    window.global.loaderPanel.hide($divPanel);
                },
                error: function () {
                    window.global.loaderPanel.hide($divPanel);
                    swal("", i18next.t('erroServidor'), "error");
                }
            });
        });

    };


    var _listar = function () {
        window.global.loaderPanel.show($divPanel);

        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetRedeSocial', cache: false,
            success: function (dados) {
                var dadosLength = dados.length, html = [], item = '';
                var qntdeElementos = 0;

                if (dadosLength > 0) {
                    $elementNull.className = 'hide';
                    for (var i = 0; i < dadosLength; i++) {

                        if (dados[i].RedeSocialID == 15) {
                            $panel.find('#elemento-whatsapp').addClass('hide');
                        }
                        if (dados[i].RedeSocialID == 2) {
                            $panel.find('#elemento-linkedin').addClass('hide');
                        }
                        qntdeElementos++;


                        item = '<div class="col-sm-6 mb10 pl10 pr10" id="social-item-' + dados[i].RedeSocialID + '">';
                        item += '<div style="cursor:default" class="btn btn-sm btn-block item-add btn-social btn-' + dados[i].Fonte + '-outline" data-url="' + dados[i].Url + '" data-id="' + dados[i].RedeSocialID + '" data-fonte="' + dados[i].Fonte + '"><i class="fa fa-' + dados[i].Fonte + '"></i> <div class="pull-left" style="text-overflow: ellipsis; overflow: hidden;width:85%">' + dados[i].Url + '</div><span class="token-input-delete-token-facebook cursor-pointer btn-excluir pull-right" data-id="' + dados[i].RedeSocialID + '" style="line-height:17px">×</span><div class="clearfix"></div></div>';
                        item += '</div>';
                        html.push(item);
                    }
                    document.getElementById('social-lista').innerHTML = html.join('');
                    $panel.find('.btn-excluir').on('click', function () {
                        var id = $(this).attr('data-id');
                        _excluir(id);
                    });

                    if (qntdeElementos === 0) {
                        $panel.find('.btn-add-outro').removeClass('hide');
                    }
                    else {
                        $panel.find('.btn-add').removeClass('hide');
                        $panel.find('.btn-add-outro').addClass('hide');
                    }

                } else {
                    $elementNull.className = '';
                    document.getElementById('social-lista').innerHTML = '';
                }
                window.global.loaderPanel.hide($divPanel);
            },
            error: function () {
                window.global.loaderPanel.hide($divPanel);
            }
        });
    };
    var _salvar = function () {

        // Garante links do linkedin e do github estejam com url correto
        function linkValido(url, tipo) {
            if (isNullOrEmpty(url)) {
                return false;
            }
            //if(tipo == 'linkedin'){
            //    const regexLinkedin = /^(https?:\/\/)?([a-z]+\.)*linkedin\.com\/in\/([\w-%]+)(\/|\?.*)?$/i;
            //    return !regexLinkedin.test(url);
            //}

            //if(tipo == 'github'){
            //    const regexGithub = /^(https?:\/\/)?(www\.)?github\.com\/[a-z0-9-]+(\/|\?.*)?$/i;
            //    return !regexGithub.test(url);
            //}
        }

        //if(linkValido( $("#social-linkedin").val(),"linkedin")){
        //    toastr.error("Digite um link do LinkedIn valido", '', { "closeButton": true });
        //    return;
        //}

        //if(linkValido( $("#social-github").val(),"github")){
        //    toastr.error("Digite um link do Github valido", '', { "closeButton": true });
        //    return;
        //}

        // Formata para salvar da forma correta com codigo do pais do intltel
        let whatsAppInputValue = $("#social-whatsapp").val();
        if (!isNullOrEmpty(whatsAppInputValue)) {
            whatsAppInputValue = $("#social-whatsapp").intlTelInput("getSelectedCountryData").dialCode + ' ' + whatsAppInputValue;
        }
        var content = $panel.find('#form-social');

        window.global.loaderButton.show(content.find('button[type=submit]'));

        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveRedeSocial', cache: false,
            data: content.serialize() + '&whatsapp=' + whatsAppInputValue,
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('socialSalvaSucesso'), '', { "closeButton": true });
                    _listar();
                    progressoCurriculo();
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide(content.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };
    var _fechar = function () {
        document.getElementById('social-contentform').innerHTML = '';
        goToByScroll($divPanel);
        fecharFormCadastro();
    };
    var _abrir = function () {

        goToByScroll($divPanel);

        window.global.loaderFull.show();
        //window.global.loaderPanel.show($divPanel);
        var formulario = $panel.find('#social-contentform');

        abrirFormCadastro();
        formulario.load(_URL_FORM + "RedeSocial?v=3", function () {
            $.validate({
                form: '#form-social'
            });
            formulario.find('.close-panel').on('click', function (e) {
                _fechar();
                e.preventDefault();
            });
            formulario.find('#form-social').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });


            $panel.find('#social-lista').find('.item-add').each(function (i) {
                var _this = $(this);

                if (_this.attr('data-id') == '13') {
                    formulario.find('#social-lattes').val(_this.attr('data-url'));
                } else if (_this.attr('data-id') == '14') {
                    formulario.find('#social-site').val(_this.attr('data-url'));
                } else if (_this.attr('data-id') == '15') {
                    formulario.find('#social-whatsapp').val(_this.attr('data-url'));
                } else {
                    formulario.find('#social-' + _this.attr('data-fonte')).val(_this.attr('data-url'));
                }

            });

            formulario.find('.btn-excluir-integracao').on('click', function (e) {
                var id = $(this).attr('data-id');
                _excluir(id);
                e.preventDefault();
            });

            /// INTLTEl e Mascara
            const opcoesIntlInput = {
                initialCountry: 'auto',
                hiddenInput: "full_phone",
                formatOnDisplay: false,
                preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
                utilsScript: "/assets/lib/intl-tel-input/js/utils.js"
            };

            const inputWhatsapp = formulario.find("#social-whatsapp");

            const valorInicial = inputWhatsapp.val();

            inputWhatsapp.intlTelInput(opcoesIntlInput);

            const SPMaskBehavior = function (val) {
                return val.replace(/\D/g, '').length >= 11 ? '(00) 00000-0000' : '(00) 0000-00009';
            }

            const addMaskById = function (elementId) {
                const inputField = formulario.find(elementId);
                const initDialCode = inputField.intlTelInput("getSelectedCountryData").dialCode;

                const brasilDialCode = '55';

                const options = {
                    onKeyPress: function (number, e, field, options) {
                        inputField.mask(SPMaskBehavior, options);
                    }
                };

                while (inputField.val().includes('+')) {
                    let inputString = inputField.val();

                    let indexOfSpace = inputString.indexOf(" ");

                    if (indexOfSpace !== -1) {
                        let trimmedString = inputString.substring(indexOfSpace + 1);
                        inputField.val(trimmedString)
                    }
                }

                if (brasilDialCode == initDialCode) {
                    inputField.mask(SPMaskBehavior, options);
                }

                inputField.on("countrychange", function (e, countryData) {

                    if (brasilDialCode == countryData.dialCode) {
                        $(elementId).unmask();
                        inputField.mask(SPMaskBehavior, options);
                    }
                    else {
                        $(elementId).unmask();
                    }
                });

            };

            if (valorInicial == ' ' || valorInicial == null || valorInicial == '') {
                formulario.find("#social-whatsapp").val('')
                inputWhatsapp.intlTelInput("setCountry", "BR");
            }

            else if (!valorInicial.includes('+') && !$("#social-whatsapp").intlTelInput("getSelectedCountryData").dialCode) {
                inputWhatsapp.intlTelInput("setCountry", "BR");
            }

            addMaskById("#social-whatsapp");

            carregaMascaras(formulario);
            janelaAjuda(formulario);

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);
            //window.global.loaderPanel.hide($divPanel);
        });

    };

    var init = function () {
        _listar();

        $panel.find('.btn-add').on('click', function (e) {
            _abrir();
            e.preventDefault();
        });
        $panel.find('.btn-excluir-integracao').on('click', function (e) {
            var id = $(this).attr('data-id');
            _excluir(id);
            e.preventDefault();
        });
    }

    return init();
};

